import React, { ReactNode, useEffect, useState } from 'react';
import { useWixPatternsInitialProps } from '../WixPatternsInitialPropsProvider';
import { WixPatternsContainerProvider } from '../WixPatternsContainerProvider';
import {
  ContextType,
  PatternsLayoutType,
  WixPatternsEssentials,
} from '../../model';
import { useWixPatternsContainerOverrides } from '../WixPatternsContainerOverridesContext';
import { buildWixPatternsContainer } from '../../state';

export interface CairoProviderBaseProps {
  children?: ReactNode;
  localCache?: boolean;
  contextType?: ContextType;
  layoutType?: PatternsLayoutType;
  useRelativeSidePanel?: boolean;
}

export interface CairoProviderProps extends CairoProviderBaseProps {
  value: WixPatternsEssentials;
}

export function CairoProvider({
  value,
  children,
  localCache = true,
  contextType = 'SITE',
  layoutType,
  ...rest
}: CairoProviderProps) {
  const containerOverrides = useWixPatternsContainerOverrides();
  const initialProps = useWixPatternsInitialProps();

  const [container] = useState(() =>
    buildWixPatternsContainer(value, {
      containerOverrides,
      initialProps,
      localCache,
      contextType,
      layoutType,
      ...rest,
    }),
  );

  useState(() => {
    container.initialFetch();
  });

  useEffect(() => {
    return container.init();
  }, []);

  return (
    <WixPatternsContainerProvider value={container}>
      {children}
    </WixPatternsContainerProvider>
  );
}
